import type { AvailableGameCatalogEntry } from '../../catalog-entry.js';
import { ginRummyDescriptor } from './descriptor.js';

export const ginRummyCatalogEntry = {
  descriptor: ginRummyDescriptor,
  availability: 'production',
  load: async () => (await import('./game.js')).ginRummyGeneratorDefinition,
} satisfies AvailableGameCatalogEntry;
